<template>
    <v-dialog
        v-model="display"
        persistent
        width="500">
        <v-card>
            <v-card-title>{{title}}</v-card-title>
            <v-card-subtitle>{{ $t("JOBCARD_MAINT_SUBTITLE") }}</v-card-subtitle>
            <v-card-text>
                <div v-if="loading.data" class="text-center">
                    <v-progress-circular
                        indeterminate
                        color="primary">
                    </v-progress-circular>
                </div>
                <v-form
                    v-else
                    ref="form"
                    v-model="valid">
                    
                    <v-text-field
                        :label="$t('JOBCARD_MAINT_DESC')"
                        v-model="form.description"
                        :rules="rules.description"
                        @keypress.enter="submit">
                    </v-text-field>

                    <v-autocomplete
                        :label="$t('GROUP')"
                        v-model="form.malfaction_id"
                        :rules="rules.malfaction_id"
                        :items="malfactions"
                        :loading="loading.malfaction"
                        @focus="fetchMalfactions"
                        item-text="name"
                        item-value="id"
                        >
                    </v-autocomplete>

                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    text
                    :disabled="!valid || loading.data || loading.submit"
                    :loading="loading.submit"
                    @click="submit">
                    {{ $t("BTN_SAVE") }}
                </v-btn>
                <v-btn
                    @click="close"
                    text>
                    {{ $t("BTN_CANCEL") }}
                </v-btn>
            </v-card-actions>    
        </v-card>
        <AlertDialog
            ref="alertDialog"/>    
    </v-dialog>
</template>

<script>
import AlertDialog from '../components/AlertDialog'
import { mapActions, mapState } from 'vuex';
import { getMalfactions } from './../services/malfactions';

export default {
    name: "JobcardMaintenanceDialog",
    components: {
        AlertDialog
    },
    data() {
        return {
            id: null,
            display: false,
            editMode: false,
            valid: false,
            malfactions: [],
            form: {
                jobcard_id: null,
                description: null
            },
            rules: {
                description: [
                    v => !!v || this.$t("RULES_REQUIRED_MSG")
                ],
                malfaction_id: [
                    v => !!v || this.$t("RULES_REQUIRED_MSG")
                ]
            },
            loading: {
                data: false,
                submit: false,
                malfaction: false
            }
        }
    },
    computed: {
        ...mapState("jobcardMaintenance", ["jobcardMaintenance"]),
        title() {
            if(!this.editMode) return this.$t("JOBCARD_MAINT_NEW_TITLE");
            else return this.$t("JOBCARD_MAINT_EDIT_TITLE");
        }
    },
    methods: {
        ...mapActions("jobcardMaintenance", ["storeJobcardMaintenance", "updateJobcardMaintenance", "fetchJobcardMaintenance", "fetchJobcardMaintenances"]),
        async open(params) {
            this.display = true;
            this.loading.data = true;
            this.editMode = params.editMode;
            this.form.jobcard_id = params.jobcard_id;
            if(this.editMode) {
                this.id = params.id;
                await this.fetchJobcardMaintenance(this.id);
                this.form = this.jobcardMaintenance;
            }
            this.loading.data = false;
        },
        close() {
            this.display = false;
            this.loading.submit = false;
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
        },
        submit() {
            this.loading.submit = true;
            if(!this.editMode) {
                this.storeJobcardMaintenance(this.form)
                    .then(response => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t("SUCCESS_TITLE"), response.message);
                        this.fetchJobcardMaintenances(this.form.jobcard_id);
                    })
                    .catch(error => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), error.message);
                    })
            } else {
                this.updateJobcardMaintenance({form: this.form, id: this.id})
                    .then(response => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t("SUCCESS_TITLE"), response.message);
                        this.fetchJobcardMaintenances(this.form.jobcard_id);
                    })
                    .catch(error => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), error.message);
                    })
            }
        },
        async fetchMalfactions() {
            this.loading.malfaction = true;
            let r = await getMalfactions();
            this.malfactions = r.data;
            this.loading.malfaction = false;
        }
    }
}
</script>